const middleware = {}

middleware['page-cache'] = require('../middleware/page-cache.js')
middleware['page-cache'] = middleware['page-cache'].default || middleware['page-cache']

middleware['spa'] = require('../middleware/spa.js')
middleware['spa'] = middleware['spa'].default || middleware['spa']

export default middleware
